
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v",
      function () {
        return require("private-next-pages/v/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v"])
      });
    }
  